export var scrollToElement = function (id, shouldFocus, behavior) {
    if (behavior === void 0) { behavior = "smooth"; }
    var element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: behavior });
        if (shouldFocus) {
            var firstFocusableElement = element.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
            if (firstFocusableElement) {
                firstFocusableElement.focus();
            }
        }
    }
    else {
        console.warn("Element with id \"".concat(id, "\" not found. Please ensure the id is correct and the element exists in the DOM."));
        window.scrollTo({ top: 0, behavior: behavior });
    }
};
